export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/packaging_design.c0f10b3.svg";